import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import {MatSelectChange, MatSort } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr'
import { LoginService } from "src/app/components/Shared/Service/login_service";
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboarduiService } from '../../Shared/Service/dashboardui.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Observable } from 'rxjs';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  hotelCode: any;
  hotelName: any;
  city: any;
  channelCode: any;
  groupCode: any;
  id:any
  activeProduct: any
}
@Component({
  selector: 'app-onepage-summary',
  templateUrl: './onepage-summary.component.html',
  styleUrls: ['./onepage-summary.component.css'],
  providers: [LoginService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})

export class OnepageSummaryComponent implements OnInit {
  Val: string;
  idsProductList: idsProductList[] = [];
  // dataSource: MatTableDataSource<idsProductList>;
  // @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  // @ViewChild(MatSort, { static: false }) sort: MatSort;
  displayedColumns = ['Hotel','channelCode', 'groupCode','response'];
  apiresult: any;
  Pmscodevalue: any;
  errorMsgSubscription: boolean;
  errorMessage: string;
  displayContent: boolean;
  filterProperty: any;
  requestPayload: any;
  groupCode: any;
  hotelCodePopup: any;
  hotelNamePopup: any;
  productListPopup: any;
  responseList: any;
  ActiveProduct: any[];
  productlist: any [];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  dataObs$: Observable<any>;
  constructor(private _changeDetectorRef: ChangeDetectorRef,private apiCallIdsService: DashboarduiService, private toastr: ToastrService, 
    private datePipe: DatePipe) { 
      
    }

  display: Boolean = false;
  public User: string;
  isProgressing: Boolean = false;
  lstGetCMHotelsProperty: any = [];
  storePmsCode: string
  Userid: any = [];
  selectedProperty: any;
  isIDSUser: boolean;
  search: string;
  totalcount: any = 0;
  pageSize = 50;
  statusResult: string;
  dropdownSettingsPropList: IDropdownSettings = {};
  dropdownSettingsGroupcode: IDropdownSettings = {};
  selectedGroupcodeItem: any;
  selectedPropertyItem:any
  dropdownPropListData: any
  dropdownGroupcodeData: any
  list = [
  ]
  
  ngOnInit() {
    this.isProgressing = true;
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.errorMsgSubscription = true
    this.statusResult = "not sent"
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.getOnePageGrpCodeList();
    // this.GetOnePageProperties();
    this.dropdownSettingsGroupcode = {
      idField: 'groupcode',
      textField: 'groupName',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Group Code / Name"
    };
    this.dropdownSettingsPropList = {
      idField: 'propertyCode',
      textField: 'propertyName',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection: true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText: "Search Hotel Code / Name"
    };
  }

  getOnePageGrpCodeList() {
    this.apiCallIdsService.getOnePageGrpCodeList()
      .subscribe(
        data => {
          console.log('getOnePageGrpCodeList =', data)
          this.dropdownGroupcodeData = data
          this.isProgressing = false;
        });
  }

  changeGroupCodeSearch() {
    console.log("selected --->" + this.selectedGroupcodeItem);
    this.groupCode = this.selectedGroupcodeItem;
    if (this.selectedGroupcodeItem) {
      this.groupCode = this.selectedGroupcodeItem[0].groupcode
      console.log('groupCode = ',this.groupCode)
      this.totalcount = 0
      this.errorMsgSubscription = true
      this.errorMessage = "Please select property and load"
      this.displayContent = false
      this.apiCallIdsService.GetOnePageProperties(this.groupCode)
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          //Remove duplicate data
          this.apiresult = data;
          this.apiresult.unshift({
            "propertyCode": "All",
            "propertyName": "All Property"
          });

          this.dropdownPropListData = this.apiresult
          // if (this.SourceBy == 'Report') {
          this.selectedPropertyItem = this.getDimensionsByFilter("All");
          console.log('this.StoreValuetest', this.selectedPropertyItem[0].propertyCode);
          this.Pmscodevalue = this.selectedPropertyItem[0].propertyCode
          console.log('this.Pmscodevalue =', this.Pmscodevalue)
          // }
          console.log('Property 113 = ', data)
          this.isProgressing = false;
        });
    }
  }
  changePropertySearch() {
    // console.log('selectedPropertyItem = ',this.selectedPropertyItem)
    if (this.selectedPropertyItem) {
      if (this.selectedPropertyItem.length > 0) {
        console.log('if condition')
        console.log('selectedPropertyItem = ', this.selectedPropertyItem)
        this.totalcount = 0;
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
        this.Pmscodevalue = this.selectedPropertyItem[0].propertyCode
        console.log('pms code value = ', this.Pmscodevalue)

      } else {
        console.log('Else condition zero')
        this.errorMsgSubscription = true
        this.errorMessage = "Please select property and load"
        this.displayContent = false
      }
    } else {
      console.log('Property Not Selected')
    }
  }
  getDimensionsByFilter(propertyCode: any) {
    console.log('dropdownPropListData =', this.dropdownPropListData)
    return this.dropdownPropListData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
  }


  GetLoadMethod() {
    this.isProgressing = true;
    console.log('Pmscodevalue Result = ', this.Pmscodevalue)
    console.log('groupCode Result = ', this.groupCode)
    this.requestPayload = {
      "GROUPCODE":this.groupCode,
      "PMSCODE":this.Pmscodevalue
  }
  console.log('requestPayload = ', this.requestPayload)

    this.apiCallIdsService.readOnePageSummary(this.requestPayload)
      .subscribe((data) => {
        console.log('response =', data);
        this.isProgressing = false;
        if (data.length < 1) {
          this.displayContent = false
          this.errorMsgSubscription = true
          this.errorMessage = "No Data Found"
          this.toastr.error('No Data Found');
          this.isProgressing = false;
        }
        else {
          this.errorMsgSubscription = false
          this.displayContent = true
          this.responseList = data
          console.log('responseList = ', this.responseList)
          this.totalcount = data[0].totalCount
          this.list = []
          for(let i=0; i<this.responseList.length; i++){
            this.list.push({
              "hotelCode": this.responseList[i].hotelCode,
                  "hotelName": this.responseList[i].hotelName,
                  "city": this.responseList[i].city,
                  "channelCode": this.responseList[i].channelCode,
                  "groupCode": this.responseList[i].groupCode,
                  "ActiveProduct": [
                  ]
            })
            let productlist = []
            for(let m in this.responseList[i]){
              if(this.responseList[i][m] == 'Active'){
                console.log('Active Data =',m)
                productlist.push({
                        "title": m,
                        "status": "Active"
                      })
              }else if(this.responseList[i][m] == null){
                console.log('Non Active Data =',m)
                productlist.push({
                  "title": m,
                  "status": ""
                })
              }
            }
            this.list[i].ActiveProduct = productlist
          }
          
          console.log('final list = ', this.list)
      // this.splitArray = this.list.split(',');
      // console.log(this.splitArray);
          this.filterProperty = this.list
          this.setPagination(this.list);
          this.toastr.success('Data loaded Successfully');
          this.isProgressing = false;
        }
      });
  }

  setPagination(tableData) {
    this.dataSource = new MatTableDataSource<any>(tableData);
    this._changeDetectorRef.detectChanges();
    this.dataSource.paginator = this.paginator;
    this.dataObs$ = this.dataSource.connect();
  }
  Search(event: any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { hotelCode: { toString: () => string; }; hotelName: { toString: () => string; }; bilnub: { toString: () => string; } }) => {
      return res.hotelCode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.hotelName.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.bilnub.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if (event == '') {
      this.Val = '';
      this.totalcount = 0
      this.GetLoadMethod()
    }
  }

  pageEvent(e: any) {
    console.log('pageEvent = ', e)
    var pageIndex = e.pageIndex;
    pageIndex = pageIndex;
    console.log('pageIndex = ', pageIndex)
    this.pageSize = e.pageSize
    console.log('pageSize = ', this.pageSize)
    this.GetLoadMethod();
  }

  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }


viewActiveProduct(viewProd: any,hotelCode:any,hotelName:any) {
  console.log('viewProd = ',viewProd)
  console.log('hotelCode = ',hotelCode)
  console.log('hotelName = ',hotelName)
  this.hotelCodePopup = hotelCode
  this.hotelNamePopup = hotelName
  this.productListPopup = viewProd
  this.display = true
}

}